import { DateTime } from 'luxon';
import * as ko from 'knockout';

/** Simple required validation — replaces knockout.validation's .extend({ required: true }) */
function requiredObservable(initialValue: string = ''): KnockoutObservable<string> {
  const obs = ko.observable(initialValue) as KnockoutObservable<string>;
  (obs as any)._hasError = ko.observable(false);
  (obs as any).isValid = ko.computed(() => {
    const v = obs();
    return v !== null && v !== undefined && v.trim() !== '';
  });
  (obs as any).clearError = () => (obs as any)._hasError(false);
  return obs;
}

export interface IWatchlistData {
  WatchlistGUID: string;
  Description: string;
  LeagueGUID: string;
  SaveString: string;
  WatchlistName: string;
  UserID: string;
  CreatedOn: string;
  SortOrder: number;
  Version: number;
}

export class Watchlist {
  CreatedOn: KnockoutObservable<DateTime | null>;
  UserID: string;
  Description: KnockoutObservable<string>;
  LeagueGUID: KnockoutObservable<string>;
  SaveString: KnockoutObservable<string>;
  WatchlistName: KnockoutObservable<string>;
  WatchlistGUID: string;
  SortOrder: KnockoutObservable<number>;
  Version: number;

  constructor(data: IWatchlistData | null) {
    this.Description = ko.observable('');
    this.LeagueGUID = ko.observable('');
    this.SaveString = ko.observable('');
    this.WatchlistName = requiredObservable('');
    this.CreatedOn = ko.observable(null);
    this.SortOrder = ko.observable(0);
    this.UserID = '';
    this.WatchlistGUID = '';
    this.Version = 0;

    if (data) {
      this.WatchlistGUID = data.WatchlistGUID;
      this.Description(data.Description);
      this.LeagueGUID(data.LeagueGUID);
      this.SaveString(data.SaveString);
      this.WatchlistName(data.WatchlistName);
      this.UserID = data.UserID;
      this.CreatedOn(data.CreatedOn ? DateTime.fromISO(data.CreatedOn) : null);
      this.SortOrder(data.SortOrder);
      this.Version = data.Version;
    }

    (this.WatchlistName as any).clearError();
  }
}
